import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {UserState} from "../../api/models/user-state";
import {Subscription} from "rxjs";
import {GlobalApp} from "../../tools/global";
import {SubscriptionService} from "../../api/services/subscription.service";
import {Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import { US_ReportEmbeddedType, US_ReportEmbededExport } from "../../api/models";
import { ReportExportService } from "../../api/services";
import { GuidService } from "../../services/guid-service";

@Component({
  selector: "powerbi-widget-home",
  templateUrl: "./powerbi-widget-home.component.html",
})
export class PowerBiWidgetHomeComponent implements OnInit, OnDestroy {

  @Input() showHeader: boolean = true;

  selectedValues: string[] = [];

  userState: UserState = {
    reportOnly: false,
    userManagerOnly: false,
    invoiceManagerOnly: false,
    interactives: [],
    modifiedInteractives: [],
    xmlas: [],
    reportExportState: {},
    isInteractiveUser: false,
    isReportExportUser: false,
    isEmbeddedUser: false
  };

  userStateSubscription: Subscription = null;

  currentSelectedWidget: US_ReportEmbeddedType | undefined = undefined;
  filteredWidgetLayouts: US_ReportEmbededExport[] = [];
  currentSelectedWidgetLayout: US_ReportEmbededExport | undefined = undefined;

  currentSelectedAction: string = undefined;

  isLoading: boolean = false;

  constructor(
    public app: GlobalApp,
    private reportExportService: ReportExportService,
    private subscriptionService: SubscriptionService,
    private router: Router,
    private dialog: MatDialog
  ) {

    this.app.getAuthorizationStatus().subscribe((result) => {
      this.app.refreshUserState(this.subscriptionService);
    });
  }

  ngOnInit() {
    this.isLoading = true;

    this.userStateSubscription = this.app.userState.subscribe((userState) => {
      this.userState = userState;

      const lastStatus = this.app.getLastStatus();
      if (lastStatus.lastReportEmbeddedTypeId) {
        this.currentSelectedWidget = this.userState.reportExportState.reportEmbeddedTypes.find(x => x.reportEmbeddedTypeId === lastStatus.lastReportEmbeddedTypeId);
        this.filterExports();
        if (this.currentSelectedWidget && lastStatus.lastReportEmbeddedLayoutId) {
          this.currentSelectedWidgetLayout = this.userState.reportExportState.reportEmbeds.find(x => x.reportEmbeddedTypeId === this.currentSelectedWidget.reportEmbeddedTypeId && x.reportEmbeddedExportId == lastStatus.lastReportEmbeddedLayoutId);
        }
      }
      else {
        var first = this.userState.reportExportState.reportEmbeds[0];
        this.currentSelectedWidget = this.userState.reportExportState.reportEmbeddedTypes.find(x => x.reportEmbeddedTypeId == first.reportEmbeddedTypeId);
        this.filterExports();
        this.currentSelectedWidgetLayout = first;
      }
      this.currentSelectedAction = 'Launch';
      this.isLoading = false;
    });
  }

  ngOnDestroy() {
    this.userStateSubscription.unsubscribe();
  }

  filterExports() {
    if (this.currentSelectedWidget) {
      this.filteredWidgetLayouts = this.userState.reportExportState.reportEmbeds.filter(x => x.reportEmbeddedTypeId === this.currentSelectedWidget.reportEmbeddedTypeId);
    } else {
      this.filteredWidgetLayouts = [];
    }
  }

  selectWidgetType() {
    if (!this.isLoading) {
      this.currentSelectedWidgetLayout = undefined;
      this.filterExports();
      this.app.setLastWidget(this.currentSelectedWidget.reportEmbeddedTypeId, undefined);
    }
  }

  selectWidgetLayout() {
    if (!this.isLoading) {
      this.app.setLastWidget(this.currentSelectedWidget.reportEmbeddedTypeId, this.currentSelectedWidgetLayout.reportEmbeddedExportId);

    }
  }

  private getGatedUrl(embed: US_ReportEmbededExport): string {
    var shiftedGuid = GuidService.ShiftGuid(embed.embeddToken);
    var newUrl = embed.embedUrl.replace('report-embed', 'report-embed-public');
    newUrl = newUrl.replace(embed.embeddToken, shiftedGuid);
    return newUrl;
  }

  goClick(): boolean {

    if (this.currentSelectedWidgetLayout) {
      if (this.currentSelectedAction === 'Launch') {
        var gatedUrl = this.getGatedUrl(this.currentSelectedWidgetLayout);
        window.open(gatedUrl, "_blank");
      } else {
        window.open(this.currentSelectedWidgetLayout.embedUrl, "_blank");
      }
    }

    return false;
  }
}
